module.exports = __webpack_public_path__ + "img/parking.388ffe87.svg";